"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Text = void 0;
var _jsxRuntime = require("react/jsx-runtime");
var Text = function Text() {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
      children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M9.04,22.68v35.09c0,2.61,2.12,4.73,4.73,4.73h37.47c2.61,0,4.73-2.12,4.73-4.73V7.23\r c0-2.61-2.12-4.73-4.73-4.73H29.21"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M18.93,17.13c2.61,0,4.73-2.12,4.73-4.73V2.5L9.04,17.13H18.93z"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "34.1",
          y1: "12.32",
          x2: "47",
          y2: "29.71"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M46.3,19.79c0.04-2.9,0.03-1.9,0.08-7.32"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M32.64,29.76v-5.93c0,0-0.29-2.29,1.72-3.57"
        })]
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
          d: "M17.68,39.56c0,0-2.02,7.57,2.65,8.83s15.08,0.95,17.47-0.44s0.88-9.27,0.88-9.27"
        }), /*#__PURE__*/(0, _jsxRuntime.jsx)("line", {
          x1: "27.26",
          y1: "55.14",
          x2: "27.26",
          y2: "55.14"
        })]
      })]
    })
  });
};
exports.Text = Text;